import { ERecommendationsActionTypes } from '../../actions/recommendations';
import { TRecommendation } from '../../types/recommendation';
import { TReduxActions } from '../../types/redux';
import { EPaginationStatus, IRecommendationsState } from '../../types/redux/recommendations';

export const recommendationsInitialState: IRecommendationsState = {
  favoriteUpdateRequestIds: {},
  recommendations: [],
  hasMore: false,
  page: 0,
  paginationStatus: EPaginationStatus.Idle,
  totalCount: null,
};

type TFavoriteUpdate = {
  offerId: number;
  isFavorite: boolean;
};

function updateFavorite(recommendations: TRecommendation[], { offerId, isFavorite }: TFavoriteUpdate) {
  return recommendations.map(recommendation =>
    recommendation.offerId === offerId
      ? {
          ...recommendation,
          isFavorite,
        }
      : recommendation,
  );
}

function removeFavoriteUpdateRequestId(requestIds: Record<number, string> | undefined, offerId: number) {
  const nextRequestIds = { ...requestIds };

  delete nextRequestIds[offerId];

  return nextRequestIds;
}

export function recommendationsReducer(state: IRecommendationsState, action: TReduxActions): IRecommendationsState {
  switch (action.type) {
    case ERecommendationsActionTypes.SetRecommendations:
      return {
        ...state,
        favoriteUpdateRequestIds: {},
        recommendations: action.payload,
      };
    case ERecommendationsActionTypes.AppendRecommendations:
      return {
        ...state,
        recommendations: [...state.recommendations, ...action.payload.recommendations],
        hasMore: action.payload.hasMore,
        page: action.payload.page,
        paginationStatus: EPaginationStatus.Idle,
        totalCount: action.payload.totalCount ?? state.totalCount,
      };
    case ERecommendationsActionTypes.SetRecommendationsPaginationStatus:
      return {
        ...state,
        paginationStatus: action.payload,
      };
    case ERecommendationsActionTypes.ToggleFavorite:
      return {
        ...state,
        favoriteUpdateRequestIds: removeFavoriteUpdateRequestId(state.favoriteUpdateRequestIds, action.payload.offerId),
        recommendations: updateFavorite(state.recommendations, action.payload),
      };
    case ERecommendationsActionTypes.StartFavoriteUpdate:
      return {
        ...state,
        favoriteUpdateRequestIds: {
          ...state.favoriteUpdateRequestIds,
          [action.payload.offerId]: action.payload.requestId,
        },
        recommendations: updateFavorite(state.recommendations, action.payload),
      };
    case ERecommendationsActionTypes.RollbackFavoriteUpdate:
      if (state.favoriteUpdateRequestIds?.[action.payload.offerId] !== action.payload.requestId) {
        return state;
      }

      return {
        ...state,
        favoriteUpdateRequestIds: removeFavoriteUpdateRequestId(state.favoriteUpdateRequestIds, action.payload.offerId),
        recommendations: updateFavorite(state.recommendations, action.payload),
      };
    case ERecommendationsActionTypes.FinishFavoriteUpdate:
      if (state.favoriteUpdateRequestIds?.[action.payload.offerId] !== action.payload.requestId) {
        return state;
      }

      return {
        ...state,
        favoriteUpdateRequestIds: removeFavoriteUpdateRequestId(state.favoriteUpdateRequestIds, action.payload.offerId),
      };
    default:
      return state || recommendationsInitialState;
  }
}
